(() => {
 const setup=()=>{
  const root=document.querySelector('#FFLCustomizer'),node=document.querySelector('[data-ffl-radar-config]'),form=document.querySelector('product-form form');
  if(!root||!node||!form||root.dataset.relationshipReady)return;
  let config;try{config=JSON.parse(node.textContent);}catch{return;}
  if(!['V403','V404','V501','V502','V503','V504','V609','V610'].includes(config.code))return;
  const group=root.querySelector('[data-radar-fields]');if(!group)return;root.dataset.relationshipReady='true';
  const select=(name,labelText,values,marker)=>{
   const label=document.createElement('label');label.textContent=labelText;
   const input=document.createElement('select');input.name='properties['+name+']';input.required=true;input.setAttribute('form',form.getAttribute('id'));input.setAttribute(marker,'');
   for(const [value,text]of values){const option=document.createElement('option');option.value=value;option.textContent=text;input.append(option);}
   label.append(input);group.prepend(label);return input;
  };
  if(config.petCount){
   const count=select('Number of pets','How many pets are in this room portrait?',[['3','3 pets'],['2','2 pets'],['1','1 pet']],'data-relationship-pets');
   const update=()=>{
    for(let n=1;n<=3;n++){
     const field=root.querySelector('[name="properties[Pet '+n+' reference and place]"]');if(!field)continue;
     const active=n<=Number(count.value);field.disabled=!active;field.required=active;field.closest('label').hidden=!active;
    }
   };count.addEventListener('change',update);update();
  }
  if(config.storyBasis)select('Story basis','Is this a confirmed memory or an imagined scene?',[['','Choose a story basis'],['confirmed-memory','A real incident I confirm'],['imagined-scene','A playful imagined illustration']],'data-story-basis');
  const message=root.querySelector('[name="properties[Personalized message]"]');
  if(message){
   const wording=document.createElement('input');wording.type='hidden';wording.name='properties[Printed wording]';wording.setAttribute('form',form.getAttribute('id'));root.append(wording);
   const update=()=>{wording.value=message.value.trim()||config.defaultWording;};message.placeholder=config.defaultWording;message.addEventListener('input',update);form.addEventListener('submit',update,true);update();
  }
 };
 setup();document.addEventListener('shopify:section:load',setup);
})();
